<template>
  <v-card flat color="transparent">
    <template v-if="!hideHeader">
      <v-card-text class="py-0">
        <v-row>
          <v-col cols="auto" class="my-auto">
            <v-img :src="icon || $images.COREBOARD_ICON"></v-img>
          </v-col>
          <v-col
            :cols="$vuetify.breakpoint.smAndDown ? null : 'auto'"
            class="text-h5 font-weight-bold"
          >
            <v-card-title class="px-0">
              {{ title }}
            </v-card-title>
            <v-card-subtitle v-if="subTitle" class="px-0">
              {{ subTitle }}
            </v-card-subtitle>
          </v-col>
          <v-spacer v-if="!$vuetify.breakpoint.smAndDown"> </v-spacer>
          <v-col
            class="my-auto"
            :cols="$vuetify.breakpoint.smAndDown ? '12' : 'auto'"
            v-if="isAdminOrManager && businessMetrics.length > 1"
          >
            <v-select
              label="Business Metric"
              v-model="businessMetricId"
              outlined
              dense
              hide-details
              :items="businessMetrics"
              item-text="name"
              item-value="id"
              class="min-width"
            >
            </v-select>
          </v-col>
          <v-col
            class="my-auto"
            :cols="$vuetify.breakpoint.smAndDown ? 12 : 'auto'"
            v-if="!annualReviewId && !hideFilter"
          >
            <timeframe-select v-model="filter" two-lines></timeframe-select>
          </v-col>
          <v-col
            class="my-auto"
            :cols="$vuetify.breakpoint.smAndDown ? 12 : 'auto'"
            v-if="settings.isNonLitePlan"
          >
            <template v-if="allowChange">
              <v-btn
                :outlined="!showRemove"
                :color="showRemove ? 'primary' : 'secondary'"
                block
                @click="$emit('change')"
              >
                Filter
                <v-icon class="ml-2">filter_list</v-icon>
              </v-btn>
            </template>
            <v-select
              v-if="items && items.length"
              outlined
              dense
              v-model="coreBoardId"
              :items="items"
              item-text="name"
              item-value="id"
              hide-details
              @change="$emit('change', coreBoardId)"
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
    </template>
    <v-container class="py-0">
      <v-row>
        <template v-if="!loading">
          <v-col
            cols="12"
            sm="6"
            md="4"
            v-for="(item, i) in coreCards"
            :key="i"
          >
            <core-card
              :identifier="coreCard"
              :annual-review-id="annualReviewId"
              :startDate="startDate"
              :type="item"
              :name="name"
            ></core-card>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
            v-if="!settings.isPaidPlan && is_admin"
          >
            <v-card height="100%" to="/billing">
              <v-card-text class="fill-height d-flex align-center">
                <v-row>
                  <v-col
                    cols="12"
                    class="pb-0 text-truncate text-h6 secondary--text font-weight-bold"
                  >
                    Want more data?
                  </v-col>
                  <v-col cols="12">
                    There is way more to culture tracking than one eNPS
                    question, so let's get everything setup & scheduled. You'll
                    be able to manage your questions, send frequency and start
                    date.
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </template>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import CoreCard from "@/components/corecard/CoreCard";
import TimeframeSelect from "@/components/reporting/TimeframeSelect";
import coreCardTypeMixins from "@/helpers/mixins/coreCardTypes";
import moment from "moment";
export default {
  name: "CoreBoard",
  components: {
    CoreCard,
    TimeframeSelect
  },
  mixins: [coreCardTypeMixins],
  props: {
    hideHeader: { type: Boolean, default: false },
    user: { type: Object },
    manager: { type: Object },
    company: { type: Object },
    team: { type: Object },
    coreValue: { type: Object },
    annualreview: { type: Object },
    mission: { type: Boolean, default: false },
    items: { type: Array },
    titleOverride: { type: String },
    allowChange: { type: Boolean, default: false },
    showRemove: { type: Boolean, default: false },
    subTitle: { type: String },
    icon: { type: String },
    hideFilter: { type: Boolean, default: false }
  },
  data: () => ({
    loading: true,
    startDate: null,
    coreBoardId: 3,
    filter: null
  }),
  computed: {
    isAdminOrManager() {
      return this.is_admin || this.is_manager;
    },
    annualReviewId() {
      return (this.annualreview || {}).id;
    },
    coreCards() {
      let list = [];

      this.settings.coreCardTypes.forEach(x => {
        if (this.getCoreCardVisible(x)) {
          list.push(
            Object.assign(x, {
              sort: this.getCoreCardSort(x),
              icon: this.getCoreCardIcon(x)
            })
          );
        }
      });

      return this._.orderBy(list, ["sort"], ["asc"]);
    },
    coreCard() {
      let val = { type: this.$enums.coreCardIdTypes.COMPANY };
      if (this.user) {
        val = { id: this.user.id, type: this.$enums.coreCardIdTypes.MEMBER };
      } else if (this.team) {
        val = { id: this.team.id, type: this.$enums.coreCardIdTypes.TEAM };
      } else if (this.manager) {
        val = {
          id: this.manager.id,
          type: this.$enums.coreCardIdTypes.MANAGER
        };
      } else if (this.core_value) {
        val = {
          id: this.core_value.id,
          type: this.$enums.coreCardIdTypes.CORE_VALUE
        };
      }
      val.timeframeId = this.filter.timeframeId;
      val.customStartDate = this.filter.customStartDate;
      val.customEndDate = this.filter.customEndDate;
      val.customTimezone = this.filter.customTimezone;
      return val;
    },
    core_value() {
      if (this.mission) {
        return { id: "mission", name: this.t("mission.title") };
      } else if (this.coreValue) {
        return this.coreValue;
      }
      return null;
    },
    title() {
      let text = "";
      if (this.titleOverride) {
        return this.titleOverride;
      }
      if (this.user) {
        text = `${this.user.fullName}'s`;
      } else if (this.company) {
        text = `${this.company.name}'s`;
      } else if (this.team) {
        text = `${this.team.name}'s`;
      } else if (this.core_value) {
        text = this.core_value.name;
      } else if (this.manager) {
        text = `${this.manager.fullName}'s Team`;
      }
      return `${text} CoreBoard`;
    },
    name() {
      if (this.user) {
        return this.user.firstName;
      } else if (this.company) {
        return "Company";
      } else if (this.team) {
        return this.team.name;
      } else if (this.manager) {
        return `${this.manager.firstName}'s Team`;
      }
      return "";
    },
    businessMetricId: {
      get() {
        return this.business_metric_id;
      },
      set(val) {
        this.setBusinessMetricData(val);
      }
    },
    businessMetrics() {
      return [{ id: null, name: "None" }].concat(this.business_metrics);
    },
    ...mapGetters({
      business_metric_id: "reporting/business_metric_id",
      business_metrics: "company/business_metrics",
      is_admin: "profile/is_admin",
      is_manager: "profile/is_manager",
      settings: "profile/settings",
      profile: "profile/profile"
    })
  },
  created() {
    this.filter = {
      timeframeId: this.$enums.timeframes.LAST_90_DAYS,
      customStartDate: null,
      customEndDate: null,
      customTimezone: moment.tz.guess(true)
    };
    this.loading = true;
    let callArray = [this.$store.dispatch("corecard/resetCoreCards")];
    if (this.is_admin || this.is_manager) {
      callArray.push(this.$store.dispatch("company/getBusinessMetrics"));
    }
    Promise.all(callArray)
      .catch(error => {
        this.logError(error);
        this.$root.$alert(
          "Error Occurred",
          "An error occured while loading CoreBoard."
        );
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    setBusinessMetricData(val) {
      //this.list_loading = true;
      Promise.all([
        this.$store.dispatch("reporting/setBusinessMetricId", val),
        this.$store.dispatch(
          "reporting/getBusinessMetricTrend",
          Object.assign({}, this.filter, {
            businessMetricId: val
          })
        )
      ])
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading report."
          );
        })
        .finally(() => {
          //this.list_loading = false;
        });
    }
  }
};
</script>
